import { render, staticRenderFns } from "./CompanyCountryOrigin.container.vue?vue&type=template&id=5cc79070&"
import script from "./CompanyCountryOrigin.container.vue?vue&type=script&lang=ts&"
export * from "./CompanyCountryOrigin.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports